import { useEffect, useState } from 'react';
import api from 'helpers/api';
import Modal from 'components/miscellaneous/Modal/Modal';
import Loader from 'components/miscellaneous/Loader/Loader';

const ExportReport = ({ report, show, onClose }) => {
    const [ showModal, setShowModal ] = useState(false);
    const [ pdfUrl, setPdfUrl ] = useState(null);
    const [ pdfIsLoading, setPdfIsLoading ] = useState(false);

    useEffect(() => {
        if (showModal === true) {
            if (pdfUrl === null) {
                setPdfIsLoading(true);
                getPdfUrl().then((url) => {
                    setPdfUrl(url)
                });
            } else {
                setPdfIsLoading(false);
            }
        } else {
            setPdfIsLoading(false);
            setPdfUrl(null);
            onClose();
        }
    }, [ showModal ])

    useEffect(() => {
        if(show !== showModal) {
            setShowModal(show);
        }
    }, [show])

    useEffect(() => {
        if (pdfIsLoading === true) {
            setPdfIsLoading(false);
        }
    }, [ pdfUrl ])

    const getPdfUrl = async () => {
        try {
            const res = await api.get(`/report/${report.token}/download`);
            if (res.success && res.data.success) {
                return res.data.data;
            }
        } catch (e) {

        }
    }

    return (
        <Modal content={
            <div style={ {
                width: '300px',
                maxWidth: '100%',
                textAlign: 'center',
                padding: '25px 0'
            }}>
                {!pdfIsLoading ? <>
                    <h1>Your PDF is Ready</h1>
                    <a href={ pdfUrl !== null ? pdfUrl : '#' } target="_blank" download className='alma-button'>Download File</a>
                </> : <>
                    <h1>Generating PDF File</h1>
                    <p>This may take a few seconds..</p>
                    <Loader color='#ddd' />
                </>}
            </div>
        } onClose={ (e) => {
            setShowModal(false);
        } } visible={ showModal } />
    )
}

export default ExportReport;